import { ArchiveFile } from "types/archive";

export const FALLBACK_ARCHIVE_FILES: ArchiveFile[] = [
    {
        id: "1",
        fileName: "네이버_BAND_광고상품소개서_2025.07.pdf",
        fileId: "1gktvx-yQLqy0nmRGtVpMQ2PE0f2O99l9"
    },
    {
        id: "2",
        fileName: "네이버웹툰_매체소개서_2025.07.pdf",
        fileId: "14Se7El6qHrniSuc1-Cu4kppGxnF11FlC"
    },
    {
        id: "3",
        fileName: "네이버페이_광고상품소개서_2025.07.pdf",
        fileId: "1KEbGxZ8v1Fyso2SGDO7aoN_SukDYucOp"
    },
    {
        id: "4",
        fileName: "놀이의발견_광고상품소개서_2025.07.pdf",
        fileId: "1JUxkE-Tuh2Tv6rnja_5uC1DXhhy1u8MO"
    },
    {
        id: "5",
        fileName: "당근_전문가모드_광고상품소개서_2025.07.pdf",
        fileId: "1hWFMpy8GNL7c-JtGRvvgB7JUnaif0kLq"
    },
    {
        id: "6",
        fileName: "대학내일_미디어소개서_2025.07.pdf",
        fileId: "1GmP92HbyicXZy3yu1MpH_GnxN6sVCTHU"
    },
    {
        id: "7",
        fileName: "리멤버_광고상품소개서_2025.07.pdf",
        fileId: "1J8VPLla0bSMoNdNVnAIVBL6c5tLkeUY9"
    },
    {
        id: "8",
        fileName: "만개의레시피_광고상품소개서_2025.07.pdf",
        fileId: "1UQEXFlm3ErYmiBPPAiuPnqNLa88bBO9C"
    },
    {
        id: "9",
        fileName: "맘스다이어리_광고상품소개서_2025.07.pdf",
        fileId: "1TCA19w4k88hZk8m2B2Vyq_wF59k663n_"
    },
    {
        id: "10",
        fileName: "배달의민족_광고상품소개서_2025.07.pdf",
        fileId: "1WveVWmoA3Ao1LjrwOFoWEk62Z186_ABu"
    },
    {
        id: "11",
        fileName: "번개장터_광고상품소개서_2025.07.pdf",
        fileId: "1xgKoQqGcnAMk-WNwizCrkj5do9VIkfk1"
    },
    {
        id: "12",
        fileName: "블라인드_광고상품소개서_2025.07.pdf",
        fileId: "1QLZT0YAkRGwEruOTRRpQWMLgu_yIOFfU"
    },
    {
        id: "13",
        fileName: "스노우_광고상품소개서_2025.07.pdf",
        fileId: "1h-tl4aB4E-Z-s9R3xmqv00CBpcY-UrGK"
    },
    {
        id: "14",
        fileName: "스페이스클라우드_광고상품소개서_2025.07.pdf",
        fileId: "1VVNg4gCiI8qfnCe_qG-EZ6AoYI0UndsJ"
    },
    {
        id: "15",
        fileName: "슥삭_광고상품소개서_2025.07.pdf",
        fileId: "1zn67jfwOB6uSg1RT8lSrYkJDm1mmEKkp"
    },
    {
        id: "16",
        fileName: "아파트너_광고상품소개서_2025.07.pdf",
        fileId: "1OUl-rCmBq_uf6VqeM1QVZI5O0MqJpUEL"
    },
    {
        id: "17",
        fileName: "에브리타임_광고상품소개서_2025.07.pdf",
        fileId: "1PCv87a578MTTnp2H4vB9rkA7iZeTE220"
    },
    {
        id: "18",
        fileName: "에이블리_광고상품소개서_2025.07.pdf",
        fileId: "1ePj7TXNU-rSnLRtjxgp307XsyglzoL7A"
    },
    {
        id: "19",
        fileName: "열품타_광고상품소개서_2025.07.pdf",
        fileId: "1YH6lVr54tbbd3xELyIeLWDPzOk3JD5iZ"
    },
    {
        id: "20",
        fileName: "오늘의집_광고상품소개서_2025.07.pdf",
        fileId: "1yQEVY03-v8M-1v0xM7pExm7riSz4fvAY"
    },
    {
        id: "21",
        fileName: "오늘의집_오하우스애즈_광고상품소개서_2025.07.pdf",
        fileId: "1wvpJQvO7tMkCucrOIqBaaTyibrT1fNig"
    },
    {
        id: "22",
        fileName: "오늘의집_퍼포먼스_DA_광고상품소개서_2025.07.pdf",
        fileId: "1HwFwfoJaOFCUKn1aeE4Sb65gvWbhsUtK"
    },
    {
        id: "23",
        fileName: "왓챠_광고상품소개서_2025.07.pdf",
        fileId: "1UZWD4JlPpITfhDCSULFlF2sGqhrcVoMQ"
    },
    {
        id: "24",
        fileName: "왓챠피디아_광고상품소개서_2025.07.pdf",
        fileId: "10uyctiWHCh9x9JgGlCWmHx2NRN8mGZIj"
    },
    {
        id: "25",
        fileName: "인벤_광고상품소개서_2025.07.pdf",
        fileId: "1yd6IhUt9evr8yXSCPTt1FiF6gtTOVfy3"
    },
    {
        id: "26",
        fileName: "잡코리아_광고상품소개서_2025.07.pdf",
        fileId: "1HXpkK8ZKkuM8EtH4TgcTpVxiVpKF0PPM"
    },
    {
        id: "27",
        fileName: "잡코리아_매체소개서_2025.07.pdf",
        fileId: "1VybZQ1OuF-EtZzspEzDfkMLDkkpf44Kd"
    },
    {
        id: "28",
        fileName: "카카오게임_광고상품소개서_2025.07.pdf",
        fileId: "1ngbNRjOWG7FlIaBatyCDOAOK-_QkyVvh"
    },
    {
        id: "29",
        fileName: "카카오모빌리티_디스플레이광고_2025.07.pdf",
        fileId: "1tdCCD5BthYs6QWFyacDdCSjLVh9gh6QM"
    },
    {
        id: "30",
        fileName: "카카오모빌리티_리워드광고_2025.07.pdf",
        fileId: "1kl0_4iKGi1yYZ7FUsYn3IIoTj9Ex27nv"
    },
    {
        id: "31",
        fileName: "카카오모빌리티_옥외광고_2025.07.pdf",
        fileId: "1eg2BD0SDLuPe794hF3cuqFvpuxvw4mkx"
    },
    {
        id: "32",
        fileName: "카카오모빌리티_카카오_T_RSE_2025.07.pdf",
        fileId: "1GbGO-F2ycCuMgF7MHLSBhN0KTjGg6R0F"
    },
    {
        id: "33",
        fileName: "카카오모빌리티_택시래핑_2025.07.pdf",
        fileId: "1Rb7nWtWCa4oMlSLdMEYprVWvS55pr8Yl"
    },
    {
        id: "34",
        fileName: "카카오뱅크_광고상품소개서_2025.07.pdf",
        fileId: "1CGzu9i_dGVtATHsJNSvEr6Yhyuz9TPHg"
    },
    {
        id: "35",
        fileName: "카카오페이_광고상품소개서_2025.07.pdf",
        fileId: "1YVXkAGmZs7rr2veRF23MfLy9L742rFWr"
    },
    {
        id: "36",
        fileName: "코멘토_매체소개서_2025.07.pdf",
        fileId: "1_MEEZKSfaKWE_lharA3VyRbX7t0YcdSw"
    },
    {
        id: "37",
        fileName: "키즈노트_광고상품소개서_2025.07.pdf",
        fileId: "1hWz-q7XIsiwrkkkCN-5DEbsDMJBAHYAJ"
    },
    {
        id: "38",
        fileName: "프립_광고상품소개서_2025.07.pdf",
        fileId: "1cgcXrjgVF7S7kekQvwt0gl9Y_V4D2mDe"
    },
    {
        id: "39",
        fileName: "피터팬의좋은방구하기_광고상품소개서_2025.07.pdf",
        fileId: "1YBhcxCD9sz38HZa-IloWaIf_-Nk2xj74"
    },
    {
        id: "40",
        fileName: "핀크럭스_광고상품소개서_2025.07.pdf",
        fileId: "1fP8IOCX7Dw4XCfcKPvqFuFTivI3hGuZg"
    },
    {
        id: "41",
        fileName: "ADN_서비스소개서_2025.07.pdf",
        fileId: "10kqdAkfafuVdeRcGCipPVLjdOMqVUf0N"
    },
    {
        id: "42",
        fileName: "OP.GG_광고상품소개서_2025.07.pdf",
        fileId: "1Y_KtG2YFwhYDmv94a20x-EBUxyyVqFzU"
    },
    {
        id: "43",
        fileName: "SK_Planet_AD_광고상품소개서_2025.07.pdf",
        fileId: "1Icupi95oW7eBytU5KCmEqEWbJYG8jdfi"
    },
    {
        id: "44",
        fileName: "SMR_광고상품소개서_2025.07.pdf",
        fileId: "1tQVUYa0vEZmer6n8b3qRPcyIFzVKSRb-"
    },
    {
        id: "45",
        fileName: "SOOP_광고상품소개서_2025.07.pdf",
        fileId: "1LvGYsozEox7jWm2FvRI25Zh2_PNa_qSB"
    },
    {
        id: "46",
        fileName: "TMAP_광고상품소개서_2025.07.pdf",
        fileId: "1DKoSQ_0o0Hl_SBNYsD0SLsLkgPUv1E2T"
    },
    {
        id: "47",
        fileName: "TMAP_로컬_광고상품소개서_2025.07.pdf",
        fileId: "1-tCBfathJ6x-L4m-jM-5ZOvoPftLKoWa"
    },
    {
        id: "48",
        fileName: "TMAP_문자_광고상품소개서_2025.07.pdf",
        fileId: "11STWxZwdKhULco5rdbI8M_UVE5DcGKcG"
    },
    {
        id: "49",
        fileName: "TNK_광고상품소개서_2025.07.pdf",
        fileId: "1AeHFhkjhRvFXSng6ulofsac35y7eUZAT"
    },
    {
        id: "50",
        fileName: "YES24_광고상품소개서_2025.07.pdf",
        fileId: "1IzLuigW9ra-SkR0zZIoXQAqWvoRCZldU"
    }
];
